import React from 'react';
import theme from './theme';
import translations from './i18n/';
import { buildDefaultI18n } from '@its/redux';
import PermIdentity from 'material-ui/svg-icons/action/perm-identity';
import header from './images/header.png';

export default {
  theme,
  user: {
    roles: [],
  },
  i18n: buildDefaultI18n(translations),
  framework: {
    loader: {
      visible: false,
      overlay: true,
    },
    snackBar: {
      message: '',
      show: false,
      initiallyOpen: false,
    },
  },
  app: {
    drawerMenu: {
      appBar: {
        title: 'DISPLAY_MANAGER',
        navigateBack: false,
      },
      header: {
        username: '',
        email: '',
        avatar: {
          icon: <PermIdentity />,
        },
        backgroundImage: header,
      },
      items: [],
    },
    displays: {
      items: [],
      detail: {},
      list: {},
    },
    timers: {
      items: [],
      detail: {},
      list: {},
    },
    templates: {
      items: [],
      detail: {},
      list: {},
      maps: {
        items: [],
        detail: {},
        lists: [],
      },
    },
    departments: {
      items: [],
      detail: {},
      list: {},
      filterList: [],
    },
    plugins: {
      items: [],
      list: {},
    },
  },
};



/** WEBPACK FOOTER **
 ** ./src/initialState.js
 **/